module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.resultado.id) ? _c('v-card', [_c('v-toolbar', {
    style: (("background-color: " + (_vm.resultado.empresa.cor)))
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(" " + _vm._s(_vm.nomeFantasia))])], 1), _vm._v(" "), _c('v-card-text', [(_vm.resultado.id) ? _c('v-flex', {
    attrs: {
      "lg12": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "xl12": ""
    }
  }, [_c('h1', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.resultado.nomePaciente))]), _vm._v(" "), (_vm.resultado.cpfPaciente) ? _c('h2', {
    staticClass: "subheading"
  }, [_vm._v("\n        CPF: " + _vm._s(_vm.resultado.cpfPaciente) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.resultado.dataNascimento) ? _c('h2', {
    staticClass: "subheading"
  }, [_vm._v("\n        Data Nascimento: " + _vm._s(_vm.resultado.dataNascimento) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.resultado.dataAssinatura == null) ? _c('h2', [_vm._v("Data Publicação: "), _c('strong', [_vm._v(_vm._s(_vm.moment(_vm.resultado.dataCadastro).format('DD/MM/YYYY hh:mm')) + " ")]), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.resultado.dataAssinatura) ? _c('h2', [_vm._v("Data Assinatura: "), _c('strong', [_vm._v(_vm._s(_vm.moment(_vm.resultado.dataAssinatura).format('DD/MM/YYYY hh:mm')) + " ")]), _c('br')]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.resultado.possuiImagem) ? _c('v-card-media', {
    ref: "resultado.id",
    attrs: {
      "src": _vm.buscarImage(_vm.resultado),
      "height": "200px"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(_vm.resultado.tipoExame) + " - " + _vm._s(_vm.resultado.modalidade))]), _vm._v(" "), _c('div', [(_vm.resultado.medico) ? _c('span', [_vm._v("Médico Executor: "), _c('strong', [_vm._v(_vm._s(_vm.resultado.medico.nome) + " ")]), _vm._v(" "), _c('strong', [_vm._v(" - CRM" + _vm._s(_vm.resultado.medico.crmUf) + "  " + _vm._s(_vm.resultado.medico.crm) + "  ")])]) : _vm._e()])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "white"
  }, [(_vm.resultado.medico) ? _c('v-btn', {
    staticClass: "ml-1 mr-1 ",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "outline": "",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.openPdf(_vm.resultado)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("picture_as_pdf")]), _vm._v(" Visualizar Laudo\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.resultado.possuiImagem) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "round": "",
      "outline": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.openViewer(_vm.resultado)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("collections")]), _vm._v(" Visualizar Imagens\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.resultado.possuiImagem) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "round": "",
      "outline": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("share")]), _vm._v(" Compartilhar\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.resultado.possuiImagem && _vm.resultado.empresa.impressao) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "round": "",
      "outline": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogImpressao = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("print")]), _vm._v(" Imagens para Impressão\n    ")], 1) : _vm._e()], 1), _vm._v(" "), _c('PdfDialog', {
    attrs: {
      "resultado": _vm.resultado,
      "link": _vm.linkPdf,
      "display": _vm.dialogPdf
    },
    on: {
      "update:display": function($event) {
        _vm.dialogPdf = $event
      }
    }
  }), _vm._v(" "), _c('ViewerDialog', {
    attrs: {
      "resultado": _vm.resultado,
      "link": _vm.linkViewer,
      "display": _vm.dialogViewer
    },
    on: {
      "update:display": function($event) {
        _vm.dialogViewer = $event
      }
    }
  }), _vm._v(" "), (_vm.resultado.id) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Compartilhar Resultado")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "xl12": ""
    }
  }, [_c('h2', {
    staticClass: "subheading"
  }, [_vm._v("Empresa: "), _c('b', [_vm._v(_vm._s(_vm.resultado.empresa.nome))])]), _vm._v(" "), (_vm.resultado.unidade) ? _c('h2', {
    staticClass: "subheading"
  }, [_vm._v("Unidade: "), _c('b', [_vm._v(_vm._s(_vm.resultado.unidade.nome))])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "subheading"
  }, [_vm._v("Paciente: "), _c('b', [_vm._v(_vm._s(_vm.resultado.nomePaciente))])]), _vm._v(" "), _c('h2', {
    staticClass: "subheading"
  }, [_vm._v("Tipo do Exame: "), _c('b', [_vm._v(_vm._s(_vm.resultado.tipoExame) + " - " + _vm._s(_vm.resultado.modalidade))])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "xl12": ""
    }
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.compartilharEmail($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.emailRules,
      "name": "email",
      "label": "Digite o e-mail"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": "",
      "xs12": "",
      "sm12": "",
      "md12": "",
      "xl12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid
    },
    nativeOn: {
      "click": function($event) {
        _vm.compartilharEmail()
      }
    }
  }, [_vm._v("Enviar por Email")]), _vm._v(" "), (_vm.detectmob()) ? _c('v-btn', {
    attrs: {
      "data-action": "share/whatsapp/share",
      "color": "green",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.compartilharWhatsapp()
      }
    }
  }, [_vm._v("WhatsApp")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('small', [_vm._v("* Este compartilhamento será váido por 7 dias")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('iframe', {
    attrs: {
      "id": "vframe",
      "frameborder": "0",
      "width": "0",
      "height": "0"
    }
  })]), _vm._v(" "), (_vm.resultado.possuiImagem && _vm.resultado.empresa.impressao) ? _c('impressao-dialog', {
    attrs: {
      "resultado": _vm.resultado,
      "mostrar": _vm.dialogImpressao
    },
    on: {
      "update:mostrar": function($event) {
        _vm.dialogImpressao = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.textAlerta) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-929b5f0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultadoCard.vue
// module id = 383
// module chunks = 1